import { render, staticRenderFns } from "./editEmailTemplateModal.vue?vue&type=template&id=08f2852f&"
import script from "./editEmailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./editEmailTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./editEmailTemplateModal.vue?vue&type=style&index=0&id=08f2852f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports